'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import styles from './organization-sticky-footer-content.module.scss';

/**
 * OrganizationStickyFooterContent renders the sticky-footer CTA for
 * authenticated organization members. The CTA text/URL/style is driven by
 * useOrgPrimaryCtaButton (via ClpPrimaryCtaButton). Price text is intentionally
 * omitted — pricing isn't surfaced to org users in the sticky footer today.
 */
export const OrganizationStickyFooterContent: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><ClpPrimaryCtaButton className={styles["enroll-now-cta-button"]} udStyle="primary" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};